export default __webpack_public_path__ + "static/DesktopMediaMainBanner-bb19ad6cc7aaa9cb438bc737c6a12182.png";